import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

/**
 * HTTP Interceptor ktory automaticky prida Authorization header so Bearer tokenom
 * k vsetkym HTTP requestom
 * 
 * Pre functional interceptor v Angular 17+
 * 
 * POZNAMKA: Pouzivame OAuthService priamo namiesto AuthService
 * aby sme sa vyhli circular dependency (AuthService -> HTTP -> Interceptor -> AuthService)
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Pouzivame OAuthService priamo aby sme sa vyhli circular dependency
  const oauthService = inject(OAuthService);
  const token = oauthService.getAccessToken();

  // Ak nemame token, pokracuj s povodnym requestom
  if (!token) {
    return next(req);
  }

  // Preskocime token pre requesty na OIDC server
  // (tie uz maju vlastne auth mechanizmy)
  if (req.url.includes('sso-dev.csob.sk') || 
      req.url.includes('sso-acc.csob.sk') ||
      req.url.includes('sso.csob.sk') ||
      req.url.includes('.well-known/openid-configuration')) {
    return next(req);
  }

  // Klonuj request a pridaj Authorization header
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });

  return next(authReq);
};
